import authReducer from "./authReducer";
import riskReducer from "./riskReducer";
import departmentReducer from "./departmentReducer";
import incidentReducer from "./incidentReducer";
import dashboardReducer from "./dashboardReducer";
import settingsReducer from "./settingsReducer";
import profileReducer from "./profileReducer";
import adminReducer from "./adminReducer";
import filesReducer from "./filesReducer";
import complianceReducer from "./complianceReducer";
import assetReducer from "./assetReducer";
import { combineReducers } from "redux";
import flowchartReducer from "./flowchartReducer";
import chatbotReducer from "./chatbotReducer";
import reportReducer from "./reportReducer";
import auditReducder from "./auditReducer"

const rootReducer = combineReducers({
  //home: homeReducer,
  auth: authReducer,
  risk: riskReducer,
  department: departmentReducer,
  incident: incidentReducer,
  dashboard: dashboardReducer,
  settings: settingsReducer,
  profile: profileReducer,
  admin: adminReducer,
  files: filesReducer,
  compliance: complianceReducer,
  asset: assetReducer,
  workflows: flowchartReducer,
  chatbot: chatbotReducer,
  reports: reportReducer,
  audits: auditReducder
});

export default rootReducer;
